





















    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';

    class Editrecharge {
        amount: number;
        userCode: string;
    }
    @Component
    export default class CreaterechargeModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        recharge: Editrecharge = new Editrecharge();
        warehouseOrderType = Enums.WarehouseOrderType;
        created() {
        }
        submit() {
            this.save();
        }
        save() {
            //this.recharge.handleType = Enums.HandleStatus.filter(function (item) { return item.value == 2 })[0].value;
            (this.$refs.systemRechargeForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.$store.dispatch({
                        type: 'user/recharge',
                        data: { id: this.$store.state.user.id, amount: this.recharge.amount }
                    });
                    (this.$refs.systemRechargeForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }

        cancel() {
            (this.$refs.systemRechargeForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.$set(this.recharge, "userCode", this.$store.state.user.userCode);
            }
        }

        rechargeRule = {
            amount: [
                { required: true, message: '充值积分不能为空', trigger: 'blur' }
            ],

        };
    }
